/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_HistoricalInputs */

const en_onboarding_genre_historical = /** @type {(inputs: Onboarding_Genre_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historical`)
};

const es_onboarding_genre_historical = /** @type {(inputs: Onboarding_Genre_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico`)
};

/**
* | output |
* | --- |
* | "Historical" |
*
* @param {Onboarding_Genre_HistoricalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_historical = /** @type {((inputs?: Onboarding_Genre_HistoricalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_HistoricalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_historical(inputs)
	return en_onboarding_genre_historical(inputs)
});